import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrButtonConfirmModule } from '../pr-button/pr-button-confirmation/pr-button-confirm.module';
import { PrButtonDropdownModule } from '../pr-button/pr-button-dropdown/pr-button-dropdown.module';
import { PrButtonModule } from '../pr-button/pr-button/pr-button.module';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { PrSearchInputComponent } from './pr-search-input.component';

@NgModule({
  declarations: [PrSearchInputComponent],
  imports: [
    CommonModule,
    FormsModule,
    PrIconModule,
    PrButtonDropdownModule,
    PrButtonConfirmModule,
    PrButtonModule,
  ],
  exports: [PrSearchInputComponent],
})
export class PrSearchInputModule {}
